/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { CardContent } from './Card'
import { Placeholder, PlaceholderImage } from 'semantic-ui-react'

const LoadingPlaceholderCardContent = () => {
    return (
      <CardContent>
          <Placeholder
            css={css`
                width: 100%;
                height: 100%;
            `}
          >
              <PlaceholderImage/>
          </Placeholder>
      </CardContent>
    )
}

export { LoadingPlaceholderCardContent }
